import React, { useState } from 'react';

import { useHistory } from 'react-router-dom';
import {
  replaceAllComplex,
  splitNumberThousands,
} from '../../../../../../mol_function';

import checkBoxCheckImage from './images/checkbox-01.svg';
import checkBoxUnCheckMouseOverImage from './images/checkbox-02.svg';
import checkBoxUnCheckImage from './images/checkbox-03.svg';

import radioBoxCheckImage from './images/checkbox-04.svg';
import radioBoxUnCheckMouseOverImage from './images/checkbox-05.svg';
import radioBoxUnCheckImage from './images/checkbox-06.svg';

interface FilterItemCellProp {
  isSelected: boolean;
  name: string;
  itemsCount: number;
  filterKey: string;
  filterValue?: string;
  //value?: string;
  radioMode: boolean;
  updateHandler: (name: string, newValue: boolean, historyHandle: any) => void;
}

interface FilterItemCellState {
  mouseOver: boolean;
}

export default function FilterItemCell(props: FilterItemCellProp) {
  let history = useHistory();
  //let state = { mouseOver: false };
  const [mouseOver, setMouseOver] = useState<boolean>(false);

  const updateHandlerIntern = () => {
    if (props.radioMode) {
      let value = props.filterValue;
      if (value == undefined) value = '';
      props.updateHandler(value, true, history);
    } else {
      let value = replaceAllComplex(props.name, [{ s: ' ', r: '+' }]);
      props.updateHandler(value, !props.isSelected, history);
    }
  };

  let input = null;

  if (props.radioMode) {
    input = (
      <div
        onClick={() => {
          updateHandlerIntern();
        }}
      >
        <img
          className="vCheckbox"
          src={
            props.isSelected
              ? radioBoxCheckImage
              : mouseOver
              ? radioBoxUnCheckMouseOverImage
              : radioBoxUnCheckImage
          }
        ></img>
      </div>
    );
  } else {
    input = (
      <div
        onClick={() => {
          updateHandlerIntern();
        }}
      >
        <img
          className="vCheckbox"
          src={
            props.isSelected
              ? checkBoxCheckImage
              : mouseOver
              ? checkBoxUnCheckMouseOverImage
              : checkBoxUnCheckImage
          }
        ></img>
      </div>
    );
  }

  let itemCountText = '0';
  if (props.itemsCount != -1) {
    itemCountText = splitNumberThousands(props.itemsCount);
  }

  let itemText = replaceAllComplex(props.name, [{ s: '\\"', r: '"' }, { s: "\\'", r: "'" }]);

  return (
    <div
      className="filterCell"
      onMouseOver={() => {
        setMouseOver(true);
      }}
      onMouseLeave={() => {
        setMouseOver(false);
      }}
      onPointerOver={() => {
        setMouseOver(true);
      }}
      onPointerLeave={() => {
        setMouseOver(false);
      }}
    >
      {input}
      <div
        className="filterText"
        onClick={() => {
          updateHandlerIntern();
        }}
      >
        <span dangerouslySetInnerHTML={{ __html: itemText }}></span>
      </div>
      {props.itemsCount != -1 ? (
        <span className="itemCount filterText">({itemCountText})</span>
      ) : null}
    </div>
  );
}
